export interface CookieCategory {
  id: string
  name: string
  description: string
  required: boolean
  enabled: boolean
}

export interface CookieConsent {
  essential: boolean
  analytics: boolean
  marketing: boolean
  // preferences: boolean
  timestamp: number
  version: string
}

export interface CookieConsentContextType {
  consent: CookieConsent | null
  showBanner: boolean
  showPreferences: boolean
  acceptAll: () => void
  rejectAll: () => void
  savePreferences: (preferences: Partial<CookieConsent>) => void
  openPreferences: () => void
  closePreferences: () => void
  closeBanner: () => void
  hasConsent: (category: keyof Omit<CookieConsent, 'timestamp' | 'version'>) => boolean
}

export const COOKIE_CATEGORIES: CookieCategory[] = [
  {
    id: 'essential',
    name: 'Essential',
    description: 'These cookies are necessary for the website to function and cannot be switched off in our systems.',
    required: true,
    enabled: true
  },
  {
    id: 'analytics',
    name: 'Analytics',
    description: 'Help us understand how visitors interact with the website by collecting and reporting information anonymously.',
    required: false,
    enabled: false
  },
  {
    id: 'marketing',
    name: 'Marketing',
    description: 'Used to track visitors across websites to deliver more relevant ads and content based on your interests.',
    required: false,
    enabled: false
  },
  // {
  //   id: 'preferences',
  //   name: 'Preferences',
  //   description: 'Remember your settings and preferences to provide a personalized experience.',
  //   required: false,
  //   enabled: false
  // }
]

export const CONSENT_VERSION = '1.0.0'
export const CONSENT_COOKIE_NAME = 'waltz-ai-cookie-consent'
export const CONSENT_EXPIRY_DAYS = 365 